<div class="quarterly-feedback-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text"  (click)="navigateToVendorManagement()">
      {{routesEnum.feedbackForm}}
    </span>
  </div>

  <div class="quarterly-feedback-form">
    <h2 class="quarterly-feedback-heading">
      {{ quarterlyFeedback.feedbackHeading }}
    </h2>
    <form [formGroup]="quarterlyFeedbackForm">
      <div class="section-container">
        <div class="section-title">{{ quarterlyFeedback.feedbackTitle }}</div>
        <div class="section-form">
          <ng-container>
            <emerald-input
              [label]="quarterlyFeedback.msaRateCardCompliance"
              [outlined]="true"
              [leadingIcon]="quarterlyFeedback.personIcon"
              formControlName="msaRateCard"
              [isValid]="isFieldValid('msaRateCard')"
              [errorText]="getFieldError('msaRateCard')"
            >
            </emerald-input>
          </ng-container>
          <emerald-input
            [label]="quarterlyFeedback.assetCompliance"
            [outlined]="true"
            [leadingIcon]="quarterlyFeedback.personIcon"
            formControlName="assetCompliance"
            [isValid]="isFieldValid('assetCompliance')"
            [errorText]="getFieldError('assetCompliance')"
          >
          </emerald-input>

          <app-file-upload
            #msaUploadFileUpload
            formControlName="msaUpload"
            label="quarterlyFeedback.msaUpload"
            [error]="fileErrors['msaUpload']"
            [selectedFile]="selectedFiles['msaUpload']"
            [isSubmitted]="isSubmitted"
            (fileSelected)="onFileSelected($event, 'msaUpload')"
            (fileRemoved)="onFileRemoved('msaUpload')"
          ></app-file-upload>

          <app-file-upload
            #assetUploadFileUpload
            formControlName="assetUpload"
            label="quarterlyFeedback.assetUpload"
            [error]="fileErrors['assetUpload']"
            [selectedFile]="selectedFiles['assetUpload']"
            [isSubmitted]="isSubmitted"
            (fileSelected)="onFileSelected($event, 'assetUpload')"
            (fileRemoved)="onFileRemoved('assetUpload')"
          ></app-file-upload>

            <emerald-input
              [label]="quarterlyFeedback.sowCompliance"
              [outlined]="true"
              [leadingIcon]="quarterlyFeedback.personIcon"
              formControlName="sowCompliance"
              [isValid]="isFieldValid('sowCompliance')"
              [errorText]="getFieldError('sowCompliance')"
            >
            </emerald-input>
            <emerald-input
              [label]="quarterlyFeedback.invoiceCompliance"
              [outlined]="true"
              [leadingIcon]="quarterlyFeedback.personIcon"
              formControlName="invoiceCompliance"
              [isValid]="isFieldValid('invoiceCompliance')"
              [errorText]="getFieldError('invoiceCompliance')"
            >
            </emerald-input>
          <app-file-upload
            #sowUploadFileUpload
            formControlName="sowUpload"
            label="quarterlyFeedback.sowUpload"
            [error]="fileErrors['sowUpload']"
            [selectedFile]="selectedFiles['sowUpload']"
            [isSubmitted]="isSubmitted"
            (fileSelected)="onFileSelected($event, 'sowUpload')"
            (fileRemoved)="onFileRemoved('sowUpload')"
          ></app-file-upload>

          <app-file-upload
            #invoiceUploadFileUpload
            formControlName="invoiceUpload"
            label="quarterlyFeedback.invoiceUpload"
            [error]="fileErrors['invoiceUpload']"
            [selectedFile]="selectedFiles['invoiceUpload']"
            [isSubmitted]="isSubmitted"
            (fileSelected)="onFileSelected($event, 'invoiceUpload')"
            (fileRemoved)="onFileRemoved('invoiceUpload')"
          ></app-file-upload>
        </div>
      </div>
      <div class="button-container">
        <emerald-button [type]="'Secondary'" (onClick)="onCancel()">Cancel</emerald-button>
        <emerald-button [type]="'Primary'" (onClick)="onSave()"
          >Save</emerald-button
        >
      </div>
    </form>
  </div>
</div>

<app-modal-wrapper *ngIf="showVendorProfile" [showModal]="showVendorProfile">
    <app-vendor-profile-page
      [vendorData]="selectedVendor"
      (close)="showVendorProfile = false"
    ></app-vendor-profile-page>
  </app-modal-wrapper>